// extracted by mini-css-extract-plugin
export default {"card":"OrderConfirmation_card__F+rVj","buttonsContainer":"OrderConfirmation_buttonsContainer__krqEj"};